$( function () {
    $(document).on('click', '.js-dropdown', e => { 
        const $target = $(e.currentTarget)
        const $container = $target.find('.js-dropdown-container')
        $target.toggleClass('active') 
        $container.fadeToggle(300)
    })

    $(document).on('click', e => {
        if ( !$('.js-dropdown').is(e.target) && $('.js-dropdown').has(e.target).length === 0 ) {
            $('.js-dropdown').each( ( i, el ) => { 
                const $target = $(el)
                const $container = $target.find('.js-dropdown-container')
                $target.removeClass('active') 
                $container.fadeOut(150)
            })
        }
    })
})